import classNames from 'classnames';
import styles from './FlexibleTextArea.module.css';
import React from 'react';

type FlexibleTextAreaProps = {
	value: string;
	onChange: (value: string) => void;
	onBlur?: (evt: React.ChangeEvent<HTMLTextAreaElement>) => void;
	onEnter?: (evt: React.KeyboardEvent<HTMLTextAreaElement>) => void;
	disabled?: boolean;
	testId?: string;
	maxLength?: number;
};

export const FlexibleTextarea = React.forwardRef<HTMLTextAreaElement, FlexibleTextAreaProps>(
	({ value, onChange, onBlur, disabled, testId, onEnter, maxLength }, ref) => {
		return (
			<div className={classNames(styles.FlexibleTextarea)} data-textarea-value={value}>
				<textarea
					onInput={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
						onChange(event.target.value);
					}}
					spellCheck={false}
					value={value}
					rows={1}
					onBlur={onBlur}
					ref={ref}
					disabled={disabled}
					data-testid={testId}
					onKeyDown={(event: React.KeyboardEvent<HTMLTextAreaElement>) => {
						if (event.key === 'Enter' && !event.ctrlKey) {
							event.preventDefault();
							event.stopPropagation();
							onEnter?.(event);
						} else if (event.key === 'Enter' && event.ctrlKey) {
							onChange(event.currentTarget.value + '\n');
						}
					}}
					maxLength={maxLength}
				/>
			</div>
		);
	}
);
